/**
 * @param Array[object] 传入的数组，每个元素都是一个对象。
 * @param String 需要对比的对象key
 * @param String 需要比对的字符串
 * @return Number or Bolean
 */
export default (arr, key, str) => {
    let result = false
    arr.forEach(element => {
        if (element[key] === str) {
            result = true
        }
    });

    return result
}


// WEBPACK FOOTER //
// ./src/common/utils/include.js